export default __webpack_public_path__ + "static/media/Arburg_Logo.39caac10.svg";